export const rights = {
	NONE: 'NONE',
	READONLY: 'READONLY',
	WRITE: 'WRITE',
	ADMIN: 'ADMIN'
} as const;

export type IRight = typeof rights[keyof typeof rights];
